import { z } from "zod";

import { preProcessToInt } from "./preProcessToInt";

export const ColorIndexSchema = z.preprocess(preProcessToInt, z.number().int());
